import { getIndexedLocationFilters, getMarketFromCityState } from '@atc/bonnet-reference';
export const formatTrimCode = function () {
  var _trimCode$replace;
  let trimCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return (_trimCode$replace = trimCode.replace(/[ .]+/g, '-')) === null || _trimCode$replace === void 0 ? void 0 : _trimCode$replace.toLowerCase();
};

// Verify if a single make/model/trim exists in the query and returns each respective value.
export const getSingleMakeModelTrim = query => {
  const {
    makeCode,
    modelCode,
    trimCode
  } = query;
  let make;
  let model;
  let trim;
  if (Array.isArray(makeCode)) {
    if (makeCode.length === 1) {
      [make] = makeCode;
    }
  } else {
    make = makeCode;
  }
  if (Array.isArray(modelCode)) {
    if (modelCode.length === 1) {
      [model] = modelCode;
    }
  } else {
    model = modelCode;
  }
  if (Array.isArray(trimCode)) {
    if (trimCode.length === 1) {
      [trim] = trimCode;
    }
  } else {
    trim = trimCode;
  }
  return make && model && trim ? {
    make,
    model,
    trim
  } : {};
};
export const getLocationFromUrl = async url => {
  const locationRegex = new RegExp(/^([A-Za-z\-.']+)(?:-)+([A-Za-z]{2})(?=-)(?=.\d)(?:-)+(\d{5})$/); // city-state-zip
  const locationNozipRegex = new RegExp(/^([A-Za-z\-.']+)(?:-)+([A-Za-z]{2}$)/); // city-state
  const splitPath = url.split('/');
  let location = splitPath.pop();

  // check to match patten first
  const noZipLocationMatch = locationNozipRegex.test(location);
  const locationMatch = locationRegex.test(location);
  if (locationMatch || noZipLocationMatch) {
    location = locationMatch ? location.slice(0, -6) : location; // drop the zip code if it matches the legacy pattern
    const state = location.slice(-3).replace('-', '').toUpperCase();
    const city = location.slice(0, -3);

    // confirm the slug is a known city-state by searching indexed locations and markets data
    const gilRes = await getIndexedLocationFilters({
      city,
      state
    });
    if (gilRes.success) {
      return gilRes.success;
    }
    const gmRes = await getMarketFromCityState({
      city,
      state
    });
    return gmRes.success;
  }
  return locationMatch;
};